var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDownIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.13807 3.52827C4.87772 3.26792 4.45561 3.26792 4.19526 3.52827C3.93491 3.78862 3.93491 4.21073 4.19526 4.47108L7.5286 7.80441C7.78894 8.06476 8.21106 8.06476 8.4714 7.80441L11.8047 4.47108C12.0651 4.21073 12.0651 3.78862 11.8047 3.52827C11.5444 3.26792 11.1223 3.26792 10.8619 3.52827L8 6.3902L5.13807 3.52827ZM5.13807 8.19494C4.87772 7.93459 4.45561 7.93459 4.19526 8.19494C3.93491 8.45529 3.93491 8.8774 4.19526 9.13775L7.5286 12.4711C7.78894 12.7314 8.21106 12.7314 8.4714 12.4711L11.8047 9.13775C12.0651 8.8774 12.0651 8.45529 11.8047 8.19494C11.5444 7.93459 11.1223 7.93459 10.8619 8.19494L8 11.0569L5.13807 8.19494Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDownIcon);
export default __webpack_public_path__ + "static/media/down-icon.d80e6fd0f8e4b194270c6c4252bb4db6.svg";
export { ForwardRef as ReactComponent };